"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Measurements;

var _react = require("@chakra-ui/react");

var _react2 = _interopRequireWildcard(require("react"));

var _measurements = require("../utils/measurements");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function Round2dec(number) {
  return Math.round(number * 100) / 100;
}

var Row = function Row(_ref) {
  var label = _ref.label,
      value = _ref.value;
  return /*#__PURE__*/_react2.default.createElement(_react.Stack, {
    direction: "row",
    justify: "space-between"
  }, /*#__PURE__*/_react2.default.createElement("dt", null, label), /*#__PURE__*/_react2.default.createElement("dd", null, value));
};

function Measurements(_ref2) {
  var input = _ref2.input;
  var fonsterVidd = Round2dec((0, _measurements.getFonstervidd)(input.sprojs.x, input.measurements.v, input.measurements.luft, input.sprojs.size.x));
  var fonsterHojd = Round2dec((0, _measurements.getFonsterhojd)(input.sprojs.y, input.measurements.h, input.measurements.v, input.flagg, input.measurements.luft, input.sprojs.size.y, input.sprojs.enkel));
  var flaggFonsterVidd = input.flagg ? Round2dec((0, _measurements.getFlaggfonsterv)(input.measurements.v, input.measurements.luft, input.flagg.sprojs.x, input.sprojs.size.x)) : null;
  var flaggFonsterHojd = input.flagg ? Round2dec((0, _measurements.getFlaggfonsterh)(input.measurements.v, input.measurements.luft, input.flagg.sprojs.y, input.flagg.y, input.measurements.h, input.sprojs.size.y)) : null;
  var flaggFonsterHojdYttre = input.flagg ? Round2dec((0, _measurements.getFlaggFonsterPostH)(input.measurements.h, input.flagg.y)) : null;
  var bagVidd = Round2dec((0, _measurements.getBagvidd)(input.measurements.v, input.measurements.luft));
  var bagHojd = Round2dec((0, _measurements.getBaghojd)(input.measurements.h, input.measurements.v, input.flagg, input.measurements.luft));
  var inreBagVidd = Round2dec((0, _measurements.getInreBagvidd)(input.measurements.v, input.measurements.luft));
  var sprojsHojder = (0, _react2.useMemo)(function () {
    var _input$flagg, _input$flagg$sprojs, _input$flagg2, _input$flagg2$sprojs;

    var antalSprojs = (input.sprojs.romb ? 1 : input.sprojs.y) + ((_input$flagg = input.flagg) !== null && _input$flagg !== void 0 && (_input$flagg$sprojs = _input$flagg.sprojs) !== null && _input$flagg$sprojs !== void 0 && _input$flagg$sprojs.romb ? 1 : ((_input$flagg2 = input.flagg) === null || _input$flagg2 === void 0 ? void 0 : (_input$flagg2$sprojs = _input$flagg2.sprojs) === null || _input$flagg2$sprojs === void 0 ? void 0 : _input$flagg2$sprojs.y) || 0);
    var result = [];

    for (var i = 1; i <= antalSprojs; i++) {
      var sprojsHojd = Round2dec((0, _measurements.getSprojshojd)(input.sprojs.romb, input.sprojs.y, input.measurements.h, input.measurements.v, input.measurements.luft, input.flagg, i, input.sprojs.size.y, input.sprojs.enkel));
      result.push(sprojsHojd);
    }

    return result;
  }, [input.sprojs.romb, input.sprojs.y, input.sprojs.size.y, input.sprojs.enkel, input.measurements, input.flagg]);
  return /*#__PURE__*/_react2.default.createElement(_react.Stack, {
    direction: "column",
    spacing: 4
  }, /*#__PURE__*/_react2.default.createElement(_react.Box, {
    boxShadow: "md",
    borderRadius: "md",
    bg: "white",
    padding: 4
  }, /*#__PURE__*/_react2.default.createElement(_react.Stack, {
    as: "dl",
    direction: "column",
    spacing: "2"
  }, /*#__PURE__*/_react2.default.createElement(Row, {
    label: "B\xE5gbredd",
    value: "".concat(bagVidd, " mm")
  }), /*#__PURE__*/_react2.default.createElement(Row, {
    label: "B\xE5gh\xF6jd",
    value: "".concat(bagHojd, " mm")
  }), /*#__PURE__*/_react2.default.createElement(Row, {
    label: "Dagm\xE5tt bredd",
    value: "".concat(fonsterVidd, " mm")
  }), input.sprojs.enkel ? /*#__PURE__*/_react2.default.createElement(Row, {
    label: "Dagm\xE5tt bredd undre",
    value: "".concat(inreBagVidd, " mm")
  }) : null, /*#__PURE__*/_react2.default.createElement(Row, {
    label: input.sprojs.enkel ? "Dagmått höjd undre" : "Dagmått höjd",
    value: "".concat(fonsterHojd, " mm")
  }), sprojsHojder.length > 0 && /*#__PURE__*/_react2.default.createElement(_react2.default.Fragment, null, /*#__PURE__*/_react2.default.createElement("strong", null, "Spr\xF6jsm\xE5tt (ovansida karm till centrum spr\xF6js):"), sprojsHojder.map(function (sprojsHojd, index) {
    return /*#__PURE__*/_react2.default.createElement(Row, {
      key: index,
      label: "Spr\xF6js ".concat(index + 1),
      value: "".concat(sprojsHojd, " mm")
    });
  })))), input.flagg ? /*#__PURE__*/_react2.default.createElement(_react2.default.Fragment, null, /*#__PURE__*/_react2.default.createElement(_react.Heading, {
    as: "h2",
    fontSize: "md"
  }, "Flaggf\xF6nster"), /*#__PURE__*/_react2.default.createElement(_react.Box, {
    boxShadow: "md",
    borderRadius: "md",
    bg: "white",
    padding: 4
  }, /*#__PURE__*/_react2.default.createElement(_react.Stack, {
    as: "dl",
    direction: "column",
    spacing: "2"
  }, /*#__PURE__*/_react2.default.createElement(Row, {
    label: "Dagm\xE5tt bredd",
    value: "".concat(flaggFonsterVidd, " mm")
  }), /*#__PURE__*/_react2.default.createElement(Row, {
    label: "Dagm\xE5tt h\xF6jd",
    value: "".concat(flaggFonsterHojd, " mm")
  }), /*#__PURE__*/_react2.default.createElement(Row, {
    label: "Flaggpost mitt fr\xE5n karm",
    value: "".concat(flaggFonsterHojdYttre, " mm")
  })))) : null);
}